export default __webpack_public_path__ + "static/media/twitter.5fe5aede.svg";